<template>
  <div class="chart-content">内容</div>
</template>

<script>
  export default {
    name: 'Content',
    data() {
      return {

      }
    }
  }
</script>
